export default "__VITE_ASSET__BpMyREUa__"